export default function () {
	const footer = document.querySelector('.footer-wrapper');
	const footerTrigger = document.querySelector('.footer-trigger');

	if (footerTrigger) {
		const observerConfig = {
			rootMargin: '0px 0px -25% 0px',
			threshold: 0
		};

		const observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.intersectionRatio > 0) {
					footer.classList.add('in-view');
					observer.unobserve(entry.target);
				}
			});
		}, observerConfig);

		observer.observe(footerTrigger);
	}
}
